import React, { useEffect, useState } from "react";
import { Grid, Pagination, Typography, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useAlert } from "../../components/Alert";
import { isNotNullOrEmptyArray } from "../../globals/utils";
import { useTranslation } from "react-i18next";
import CustomAppBar from "../../components/AppBar";
import { getUserBasicDetailFromAuth } from "../../utils/common";
import { getPickupOrders } from "../../api/biomassProcurement";
import PickupOrderCard from "../../components/Biochar/PickupOrderCard";

const PickupOrders = () => {
  const { role, user_code } = getUserBasicDetailFromAuth();

  const [pickupOrders, setPickupOrders] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const navigate = useNavigate();
  const { showAlert } = useAlert();
  const { t } = useTranslation();

  useEffect(() => {
    fetchPickupOrders(1);
  }, [page]);

  const fetchPickupOrders = async (page = 1) => {
    try {
      let pickup_assigned_to;
      if (role === "VLE") {
        pickup_assigned_to = user_code;
      }
      // TODO: Add user linked farmer procurements later
      const response = await getPickupOrders(pickup_assigned_to, page);
      const { results, total_pages, current_page_number } = response;
      if (isNotNullOrEmptyArray(results)) {
        setPickupOrders(results);
        setTotalPages(total_pages);
        setPage(current_page_number);
      }
    } catch (error) {
      showAlert("error", t("Failed to fetch procurements"));
      console.error("Error fetching procurements:", error);
    }
  };

  const handleChangePage = (event, value) => {
    setPage(value);
    fetchPickupOrders(value);
  };

  const handleAddNewPickupOrder = () => {
    navigate("/create-pickup-order");
  };

  return (
    <>
      <CustomAppBar />
      <Grid
        container
        spacing={2}
        marginTop={2}
        paddingLeft={2}
        paddingRight={2}
      >
        {role == "AREA_MANAGER" && (
          <Grid
            item
            xs={12}
            sx={{ display: "flex", justifyContent: "flex-end" }}
          >
            <Button
              variant="contained"
              color="primary"
              onClick={handleAddNewPickupOrder}
              fullWidth
            >
              {t("Add New Pickup Order")}
            </Button>
          </Grid>
        )}
        {isNotNullOrEmptyArray(pickupOrders) ? (
          pickupOrders.map((pickupOrder) => (
            <>
              <Grid item xs={12} sm={6} md={4} key={pickupOrder.id}>
                <PickupOrderCard
                  pickupOrder={pickupOrder}
                  navigate={navigate}
                />
              </Grid>
              {totalPages > 1 && (
                <Grid
                  item
                  xs={12}
                  sx={{ display: "flex", justifyContent: "center", mt: 2 }}
                >
                  <Pagination
                    count={totalPages}
                    page={page}
                    onChange={handleChangePage}
                    color="primary"
                  />
                </Grid>
              )}
            </>
          ))
        ) : (
          <Grid
            item
            xs={12}
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "100vh",
            }}
          >
            <Typography variant="h6">{t("No pickup orders found")}</Typography>
          </Grid>
        )}
      </Grid>
    </>
  );
};

export default PickupOrders;
